// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"49eee959","455":"306f6fb1","977":"3894eff8"}[chunkId] + ".chunk.js";
};